import React, { useState } from "react";
import "./NewHeader.css";
import { Space, Table } from "antd";
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";

export const NewHeader = () => {
  const { user } = useAuth();
  const username = user.user;

  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  const notifications = [
    {
      key: "1",
      NotificationContent: "New task assigned to your workspace",
      date: "Today",
    },
    {
      key: "2",
      NotificationContent: "Performance report is ready to review",
      date: "Today",
    },
    {
      key: "3",
      NotificationContent: "Employee database was updated",
      date: "Yesterday",
    },
    {
      key: "4",
      NotificationContent: "Calendar activity requires attention",
      date: "Yesterday",
    },
    {
      key: "5",
      NotificationContent: "Workspace settings were updated",
      date: "2 days ago",
    },
  ];

  const notificationColumns = [
    {
      title: "Status",
      dataIndex: "img",
      key: "img",
      width: 48,
      render: () => (
        <Space size={8}>
          <span className="notification_dot" />
          <img
            className="notification_avatar"
            src="../assets/Profile.png"
            alt=""
          />
        </Space>
      ),
    },
    {
      title: "Notification",
      dataIndex: "NotificationContent",
      key: "NotificationContent",
      render: (value) => (
        <span className="notification_content">{value}</span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 78,
      render: (value) => <span className="notification_date">{value}</span>,
    },
  ];

  return (
    <>
      <header className="header1">
        <div className="header_greeting">
          <span className="header_kicker">WORKSPACE</span>
          <h2>
            Hello, <strong>{username.username}</strong>
          </h2>
          <p>Here&apos;s what&apos;s happening today.</p>
        </div>

        <div className="header_actions">
          <div className="header_location">
            <span className="location_icon_wrap">
              <img src="../assets/location.png" alt="" />
            </span>
            <div>
              <span>Current location</span>
              <strong>Live location</strong>
            </div>
            <i className="location_status" />
          </div>

          <button
            type="button"
            className={`notification_button ${
              isNotificationsOpen ? "is_selected" : ""
            }`}
            onClick={() => setIsNotificationsOpen((prev) => !prev)}
            aria-label="Open notifications"
            aria-expanded={isNotificationsOpen}
          >
            <img src="../assets/bell.png" alt="" />
            <span className="notification_badge">5</span>
          </button>

          <span className="header_divider" />

          <Link
            to="/SettingsPage"
            className="profile_button"
            aria-label="Open profile settings"
          >
            <span className="profile_avatar">
              <img
                className="profilePic_header1"
                src="../assets/Profile.png"
                alt=""
              />
            </span>
            <span className="profile_meta">
              <strong>{username.username}</strong>
              <small>{username.role || "User"}</small>
            </span>
            <span className="profile_chevron">⌄</span>
          </Link>
        </div>
      </header>

      {isNotificationsOpen && (
        <>
          <div
            className="overlay_header1"
            onClick={() => setIsNotificationsOpen(false)}
            aria-hidden="true"
          />

          <section
            className="popup-form_header1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="notifications-title"
          >
            <div className="notification_panel_header">
              <div>
                <span className="notification_eyebrow">ACTIVITY CENTER</span>
                <h3 id="notifications-title">Notifications</h3>
                <p>You have 5 recent updates.</p>
              </div>

              <button
                type="button"
                className="close_header1"
                onClick={() => setIsNotificationsOpen(false)}
                aria-label="Close notifications"
              >
                ×
              </button>
            </div>

            <div className="notification_panel_body">
              <Table
                className="notification_table"
                columns={notificationColumns}
                dataSource={notifications}
                scroll={{ y: 330 }}
                pagination={false}
                showHeader={false}
              />
            </div>

            <div className="notification_panel_footer">
              <button
                type="button"
                onClick={() => setIsNotificationsOpen(false)}
              >
                Mark all as read
              </button>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default NewHeader;
